<template>
    <ComboboxEmpty
        v-bind="delegatedProps"
        :class="cn('ds-combobox-empty', props.class)"
    >
        <slot />
    </ComboboxEmpty>
</template>

<script setup lang="ts">
import type { ComboboxEmptyProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { ComboboxEmpty } from 'reka-ui';
import { cn } from '@/lib/utils';

const props = defineProps<ComboboxEmptyProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');
</script>
